var React = require('react');

function RemoveFormat (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M160 91.9V48a16 16 0 0 1 16-16h416a16 16 0 0 1 16 16v96a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32H426.17L377 259.59l-67.06-51.83L341.82 112H224v29.36l-3.18-2.45zM336 416h-11.17l9.26-27.77L267 336.4 240.49 416H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M633.82 458.1L45.46 3.38A16 16 0 0 0 23 6.19L3.37 31.46a16 16 0 0 0 2.81 22.45l588.36 454.72a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45z","className":"fa-primary","key":2})]);
}

RemoveFormat.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = RemoveFormat;

RemoveFormat.default = RemoveFormat;
